import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TemplatesTable from "./TemplatesTable";
import Button from "components/Button";
import { Template } from "types/template-builder-types";
import { getAllTemplatesAPI } from "api/apiHelper";

const TemplateBuilderTab = () => {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState<Template[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState<boolean | undefined>(undefined);

  const fetchTemplates = async () => {
    try {
      setIsLoading(true);
      const response = await getAllTemplatesAPI(activeFilter);
      const templatesData = response.data.map((template: Template) => ({
        ...template,
        questions_count: 0,
      }));
      setTemplates(templatesData);
    } catch (error) {
      console.error("Error fetching templates:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, [activeFilter]);

  return (
    <div className="mt-5">
      <div className="mb-4 flex items-center justify-between">
        <div className="flex gap-2">
          <Button
            varient={activeFilter === undefined ? "primary" : "secondary"}
            onClick={() => setActiveFilter(undefined)}
            className="px-4 py-2"
          >
            All
          </Button>
          <Button
            varient={activeFilter === true ? "primary" : "secondary"}
            onClick={() => setActiveFilter(true)}
            className="px-4 py-2"
          >
            Active
          </Button>
          <Button
            varient={activeFilter === false ? "primary" : "secondary"}
            onClick={() => setActiveFilter(false)}
            className="px-4 py-2"
          >
            Inactive
          </Button>
        </div>
        <Button
          varient="primary"
          onClick={() => navigate("/admin-appraisals/templates/create")}
          className="px-6 py-2"
        >
          Create Template
        </Button>
      </div>
      <TemplatesTable 
        templates={templates} 
        isLoading={isLoading} 
        onRefresh={fetchTemplates}
      />
    </div>
  );
};

export default TemplateBuilderTab;
